// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__3VJK6","head":"ProcedureTableInfo_head__30oRx"};